import { INotification } from "../notification";

export interface INotificationActionResult<T = {} | unknown> {
  data?: T;
  notification: INotification;
}

export const createNotificationResult = <T>(data?: T) => {
  return {
    withNotification: (notification: INotification): INotificationActionResult<T> => {
      return {
        notification: notification,
        data: data
      };
    },
    fromResult: <U>(result: INotificationActionResult<U>): INotificationActionResult<T> => {
      return {
        notification: result.notification,
        data: data
      };
    }
  };
};
